/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignatureDTO
 */
export interface SignatureDTO {
    /**
     * 
     * @type {number}
     * @memberof SignatureDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SignatureDTO
     */
    file?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SignatureDTO
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof SignatureDTO
     */
    managerId?: number;
}

export function SignatureDTOFromJSON(json: any): SignatureDTO {
    return SignatureDTOFromJSONTyped(json, false);
}

export function SignatureDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'file': !exists(json, 'file') ? undefined : json['file'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'managerId': !exists(json, 'managerId') ? undefined : json['managerId'],
    };
}

export function SignatureDTOToJSON(value?: SignatureDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file': value.file,
        'text': value.text,
        'managerId': value.managerId,
    };
}

